import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ConsoleLoggerService, LoggerService, FeatureToggleService, HttpTokenInterceptor, HttpXsrfInterceptor } from '@nx-fe/services';
import { GlobalErrorHandler } from '../../../../../libs/error-handler/global-error-handler';
import { FormsModule } from '@angular/forms';

import { TooltipModule } from '@soti/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [CommonModule, TooltipModule, FormsModule, MatTooltipModule],
  providers: [
    FeatureToggleService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpXsrfInterceptor, multi: true },
    { provide: LoggerService, useClass: ConsoleLoggerService },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
  declarations: [],
  exports: [],
})
export class CoreModule {}
